import { useEffect } from 'react';

import { analytics } from 'analytics';

import { useCurrentUserQuery } from '../../api';
import { CurrentUserContext, hasUserJustSignedUp } from '../../utils/user';
import ErrorPage from '../ErrorPage';
import LoadingPage from '../LoadingPage';

type Props = {
  children: React.ReactNode;
};

const CurrentUserProvider: React.FC<Props> = ({ children }) => {
  const { data: user, ...query } = useCurrentUserQuery();

  // Set user context for Sentry if user email is present.
  useEffect(() => {
    if (user?.email) {
      analytics.identify(user);
      // Track Reddit Pixel sign up event
      if (hasUserJustSignedUp(user)) {
        window.rdt?.('track', 'SignUp');
      }
    } else {
      analytics.reset();
    }
  }, [user?.email]);

  if (query.isLoading) {
    return <LoadingPage />;
  }

  if (query.isError) {
    return <ErrorPage title="An error occurred while fetching user data" />;
  }

  return (
    <CurrentUserContext.Provider
      value={{
        // TODO: Don't set anonymous users to none and update the checks downstream
        user: user?.is_authenticated ? user : undefined,
        refetchUser: query.refetch,
      }}
    >
      {children}
    </CurrentUserContext.Provider>
  );
};

export default CurrentUserProvider;
